import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { OccupancyType } from '../../shared/occupancy-type.model';
import { OccupancyTypeDetailComponent } from '../../occupancy-type-detail/occupancy-type-detail.component';

@Component({
  selector: 'app-occupancy-type-modal',
  templateUrl: './occupancy-type-modal.component.html',
  standalone: true,
  imports: [SharedModule, OccupancyTypeDetailComponent],
})
export class OccupancyTypeModalComponent {
  constructor(
    private ref: MatDialogRef<OccupancyTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  occupancyType: OccupancyType = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-occupancy-type-detail
  onSavedOccupancyType(occupancyType) {
    // this.dialogSaved.emit(occupancyType); // avoid closing the dialog

    this.ref.close(occupancyType); // close the dialog
  }

  // Referenced from app-occupancy-type-detail
  onCanceledOccupancyType() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
